import { SpatialPolicy as Policy } from '@/models/spatialPolicy'
import {
  generateEnumDropdownOptions,
  ParkingTimeUnitEnum,
  SpeedUnitEnum,
} from '@/models/spatialPolicyTypes'
import i18n from '@/modules/i18n/i18n'

import { PolicyGroup, PolicyType } from '../../../utils/types'

// The same as `getTitleText` in the old `fields/Value.tsx` and `getUnitOptions` in the old
// `fields/Unit/index.tsx`. Copied, not imported, so that the old files stay as they are. When
// the old UI is deleted, only these copies stay (see `web/fe/docs/mobility-theme-flag.md`).

/** The label of the price field: "Price Per Event", "Price Per Vehicle" or "Price Per Trip". */
export const valueFieldLabel = (policy: Policy): string => {
  let titleText = 'Price'
  switch (policy.policyGroup) {
    case PolicyGroup.PARKING:
      titleText += ' Per Event'
      break
    case PolicyGroup.VEHICLE:
      titleText += ' Per Vehicle'
      break
    case PolicyGroup.TRIP:
      titleText += ' Per Trip'
      break
  }
  return i18n.t(`policiesLibrary.formValue${titleText.replaceAll(' ', '')}Title`, titleText)
}

/** The units of the policy type, or `undefined` if the policy type has no unit. */
export const unitOptions = (policy: Policy) => {
  switch (policy.policyType) {
    case PolicyType.PARKING_TIME_LIMIT:
      return generateEnumDropdownOptions(ParkingTimeUnitEnum, 'TimeUnits')
    case PolicyType.SLOW_RIDE:
      return generateEnumDropdownOptions(SpeedUnitEnum, 'SpeedUnits')
    default:
      return undefined
  }
}
